// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sectionThree-Product {
  background: #1c2640 !important;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 110px 180px;
}
.sectionThree-Product #ProductSectionThree-content {
  width: 100%;
}
.sectionThree-Product #ProductSectionThree-head {
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 43px;
  line-height: 50px;
  color: #ffffff;
  margin-bottom: 30px;
}
.sectionThree-Product #ProductSectionThree-subhead {
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  color: #d8dee8;
}
.sectionThree-Product #ProductSectionThree-card-section {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 5%;
}
.sectionThree-Product #ProductSectionThree-card1,
.sectionThree-Product #ProductSectionThree-card2,
.sectionThree-Product #ProductSectionThree-card3 {
  width: 100%;
  max-width: 330px;
  min-height: 288px;
  background: #ffffff;
  box-shadow: 5px 5px 5px rgba(51, 51, 51, 0.25);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: all 0.3s ease 0s;
  cursor: pointer;
}
.sectionThree-Product #ProductSectionThree-card1:hover,
.sectionThree-Product #ProductSectionThree-card2:hover,
.sectionThree-Product #ProductSectionThree-card3:hover {
  transform: scale(1.05);
}
.sectionThree-Product #ProductSectionThree-card1-top,
.sectionThree-Product #ProductSectionThree-card2-top,
.sectionThree-Product #ProductSectionThree-card3-top {
  display: flex;
  width: 90%;
  flex-direction: row;
  align-items: flex-start !important;
  justify-content: flex-start !important;
  margin-top: 7%;
  gap: 5%;
  padding-left: 20px !important;
}
.sectionThree-Product #ProductSectionThree-card3-top {
  margin-top: 14% !important;
}
.sectionThree-Product #ProductSectionThree-card1-head,
.sectionThree-Product #ProductSectionThree-card2-head,
.sectionThree-Product #ProductSectionThree-card3-head {
  display: flex;
  flex-direction: column;
  width: 70%;
}
.sectionThree-Product #ProductSectionThree-card1-head1,
.sectionThree-Product #ProductSectionThree-card2-head1,
.sectionThree-Product #ProductSectionThree-card3-head1 {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #1c2640;
}
.sectionThree-Product #ProductSectionThree-card1-head2,
.sectionThree-Product #ProductSectionThree-card2-head2,
.sectionThree-Product #ProductSectionThree-card3-head2 {
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 20px;
  color: #1c2640;
  margin-top: 3%;
}
.sectionThree-Product #ProductSectionThree-card1-top img,
.sectionThree-Product #ProductSectionThree-card2-top img {
  display: flex;
  flex-direction: column;
  width: 70px !important;
  height: 70px !important;
}
.sectionThree-Product #ProductSectionThree-card3-top img {
  display: flex;
  flex-direction: column;
  width: 70px !important;
  height: 50px !important;
  margin-top: -10px;
}
.sectionThree-Product #ProductSectionThree-card1-head,
.sectionThree-Product #ProductSectionThree-card2-head,
.sectionThree-Product #ProductSectionThree-card3-head {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.sectionThree-Product #ProductSectionThree-card1-para {
  width: 90%;
  height: 162px;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 28px;
  color: #1c2640;
  margin-top: 7%;
  padding: 10px 20px;
}
.sectionThree-Product #ProductSectionThree-card2-para {
  width: 90%;
  height: 153px;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 28px;
  color: #1c2640;
  margin-top: 7%;
  padding: 10px 20px;
}
.sectionThree-Product #ProductSectionThree-card3-para {
  width: 90%;
  height: 153px;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 28px;
  color: #1c2640;
  margin-top: 7%;
  padding: 10px 20px;
}
.sectionThree-Product #ProductSectionThree-discoverAll {
  color: #ec6927;
  font-weight: 500;
  font-size: 20px;
  line-height: 20px;
  width: 90%;
  margin-top: 5%;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/Product/SectionThree/sectionThree.scss"],"names":[],"mappings":"AAAA;EACC,8BAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;AACD;AACC;EACC,WAAA;AACF;AAEC;EACC,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AAAF;AAEC;EACC,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAAF;AAEC;EACC,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;AAAF;AAGC;;;EAGC,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,8CAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,4BAAA;EACA,eAAA;AADF;AAGE;;;EAEC,sBAAA;AACH;AAEC;;;EAGC,aAAA;EACA,UAAA;EACA,mBAAA;EACA,kCAAA;EACA,sCAAA;EACA,cAAA;EACA,OAAA;EACA,6BAAA;AAAF;AAEC;EACC,0BAAA;AAAF;AAEC;;;EAGC,aAAA;EACA,sBAAA;EACA,UAAA;AAAF;AAEC;;;EAGC,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAAF;AAGC;;;EAGC,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;AADF;AAIC;;EAEC,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,uBAAA;AAFF;AAKC;EACC,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;AAHF;AAMC;;;EAGC,aAAA;EACA,sBAAA;EACA,WAAA;AAJF;AAMC;EACC,UAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;AAJF;AAOC;EACC,UAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;AALF;AAOC;EACC,UAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;AALF;AAOC;EACC,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;AALF","sourcesContent":[".sectionThree-Product {\n\tbackground: #1c2640 !important;\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tpadding: 110px 180px;\n\n\t#ProductSectionThree-content {\n\t\twidth: 100%;\n\t}\n\n\t#ProductSectionThree-head {\n\t\tfont-family: Roboto;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tfont-size: 43px;\n\t\tline-height: 50px;\n\t\tcolor: #ffffff;\n\t\tmargin-bottom: 30px;\n\t}\n\t#ProductSectionThree-subhead {\n\t\tfont-family: Roboto;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tfont-size: 18px;\n\t\tline-height: 28px;\n\t\tcolor: #d8dee8;\n\t}\n\t#ProductSectionThree-card-section {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\tmargin-top: 5%;\n\t\t// padding-left: 25px;\n\t}\n\t#ProductSectionThree-card1,\n\t#ProductSectionThree-card2,\n\t#ProductSectionThree-card3 {\n\t\twidth: 100%;\n\t\tmax-width: 330px;\n\t\tmin-height: 288px;\n\t\tbackground: #ffffff;\n\t\tbox-shadow: 5px 5px 5px rgba(51, 51, 51, 0.25);\n\t\tborder-radius: 12px;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\ttransition: all 0.3s ease 0s;\n\t\tcursor: pointer;\n\n\t\t&:hover{\n\t    \t-webkit-transform: scale(1.05);\n\t\t\ttransform: scale(1.05);\n\t    }\n\t}\n\t#ProductSectionThree-card1-top,\n\t#ProductSectionThree-card2-top,\n\t#ProductSectionThree-card3-top {\n\t\tdisplay: flex;\n\t\twidth: 90%;\n\t\tflex-direction: row;\n\t\talign-items: flex-start !important;\n\t\tjustify-content: flex-start !important;\n\t\tmargin-top: 7%;\n\t\tgap: 5%;\n\t\tpadding-left: 20px !important;\n\t}\n\t#ProductSectionThree-card3-top {\n\t\tmargin-top: 14% !important;\n\t}\n\t#ProductSectionThree-card1-head,\n\t#ProductSectionThree-card2-head,\n\t#ProductSectionThree-card3-head {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\twidth: 70%;\n\t}\n\t#ProductSectionThree-card1-head1,\n\t#ProductSectionThree-card2-head1,\n\t#ProductSectionThree-card3-head1 {\n\t\tfont-style: normal;\n\t\tfont-weight: 500;\n\t\tfont-size: 16px;\n\t\tline-height: 20px;\n\t\tcolor: #1c2640;\n\t}\n\n\t#ProductSectionThree-card1-head2,\n\t#ProductSectionThree-card2-head2,\n\t#ProductSectionThree-card3-head2 {\n\t\tfont-style: normal;\n\t\tfont-weight: bold;\n\t\tfont-size: 24px;\n\t\tline-height: 20px;\n\t\tcolor: #1c2640;\n\t\tmargin-top: 3%;\n\t}\n\n\t#ProductSectionThree-card1-top img,\n\t#ProductSectionThree-card2-top img {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\twidth: 70px !important;\n\t\theight: 70px !important;\n\t}\n\n\t#ProductSectionThree-card3-top img {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\twidth: 70px !important;\n\t\theight: 50px !important;\n\t\tmargin-top: -10px;\n\t}\n\n\t#ProductSectionThree-card1-head,\n\t#ProductSectionThree-card2-head,\n\t#ProductSectionThree-card3-head {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\twidth: 100%;\n\t}\n\t#ProductSectionThree-card1-para {\n\t\twidth: 90%;\n\t\theight: 162px;\n\t\tfont-style: normal;\n\t\tfont-weight: normal;\n\t\tfont-size: 18px;\n\t\tline-height: 28px;\n\t\tcolor: #1c2640;\n\t\tmargin-top: 7%;\n\t\tpadding: 10px 20px;\n\n\t}\n\t#ProductSectionThree-card2-para {\n\t\twidth: 90%;\n\t\theight: 153px;\n\t\tfont-style: normal;\n\t\tfont-weight: normal;\n\t\tfont-size: 18px;\n\t\tline-height: 28px;\n\t\tcolor: #1c2640;\n\t\tmargin-top: 7%;\n\t\tpadding: 10px 20px;\n\t}\n\t#ProductSectionThree-card3-para {\n\t\twidth: 90%;\n\t\theight: 153px;\n\t\tfont-style: normal;\n\t\tfont-weight: normal;\n\t\tfont-size: 18px;\n\t\tline-height: 28px;\n\t\tcolor: #1c2640;\n\t\tmargin-top: 7%;\n\t\tpadding: 10px 20px;\n\t}\n\t#ProductSectionThree-discoverAll {\n\t\tcolor: #ec6927;\n\t\tfont-weight: 500;\n\t\tfont-size: 20px;\n\t\tline-height: 20px;\n\t\twidth: 90%;\n\t\tmargin-top: 5%;\n\t\tcursor: pointer;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
